import { DriveFileFragment } from "@/features/drive/queries.graphql";
import { SessionFileFragment } from "@/features/forge/forge-session/queries.graphql";

import { useStyleActions } from "../useStyleActions/useStyleActions";

export const useSetAsStyleCover = () => {
  const { updateStyle } = useStyleActions();

  const setAsStyleCover = async (
    style: DriveFileFragment["styles"][0],
    file: Pick<SessionFileFragment, "id">,
    successMessage?: string,
  ) => {
    const existingFeaturedFilesIds = style.featuredFiles.reduce<string[]>(
      (acc, featuredFile) => {
        const id = featuredFile.file?.id;
        if (id !== undefined && id !== null) {
          acc.push(id);
        }
        return acc;
      },
      [],
    );

    // Create a Set to ensure uniqueness and add the new file ID first
    const uniqueFeaturedFilesIds = new Set([
      file.id,
      ...existingFeaturedFilesIds,
    ]);

    // Convert back to array and limit to 4 items
    const updatedFeaturedFilesIds = Array.from(uniqueFeaturedFilesIds).slice(
      0,
      4,
    );

    const updateStyleInput = {
      styleId: style.id,
      featuredFiles: updatedFeaturedFilesIds.map((id) => ({
        fileId: id,
      })),
      addedWorkspaceIds: [],
      removedWorkspaceIds: [],
    };

    try {
      await updateStyle.execute(updateStyleInput, { successMessage });
    } catch (error) {
      console.error("Failed to set image as style cover:", error);
    }
  };

  return {
    setAsStyleCover,
  };
};
